import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from "react-i18next";
import { Link, useHistory, withRouter } from "react-router-dom";
import PropTypes from "prop-types";

const Footer = ( props ) =>
{
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={ 6 }>
                            &copy; { new Date().getFullYear() } © Takci.
                        </Col>
                        <Col sm={ 6 }>
                            <div className="text-sm-end d-none d-sm-block">
                                { props.t( "Designed & developed by" ) } 
                                <Link to="#"> MARKTECH</Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

Footer.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};
export default withRouter( withTranslation()( Footer ) );